import { D as d } from "./dialog-Ct72qeOD.js";
import { T as o } from "./events-CnaEWcY_.js";
import { d as c, f as l } from "./component-CAYPdBLR.js";
class u extends d {
  #e;
  connectedCallback() {
    if (
      (super.connectedCallback(),
      document.addEventListener(o.cartUpdate, this.#i, { signal: this.signal }),
      window.liquidAjaxCart?.cart)
    )
      this.#t();
    else {
      const e = () => {
        (this.#t(), document.removeEventListener("liquid-ajax-cart:init", e));
      };
      document.addEventListener("liquid-ajax-cart:init", e, { signal: this.signal });
    }
  }
  disconnectedCallback() {
    (super.disconnectedCallback(),
      this.#e &&
        (document.removeEventListener("liquid-ajax-cart:request-end", this.#e),
        (this.#e = void 0)));
  }
  #i = (e) => {
    const { data: t } = e.detail;
    if ((this.#t(e.detail?.resource), t?.requestType === "add" && window.liquidAjaxCart)) {
      this.#e && document.removeEventListener("liquid-ajax-cart:request-end", this.#e);
      const i = (a) => {
        a.detail.requestState.requestType === "get" &&
          (this.showDialog(),
          document.removeEventListener("liquid-ajax-cart:request-end", i),
          (this.#e = void 0));
      };
      ((this.#e = i),
        document.addEventListener("liquid-ajax-cart:request-end", i, { signal: this.signal }),
        window.liquidAjaxCart.get());
    }
  };
  #t(e) {
    const t = this.querySelector(".js-shipping-cost");
    if (!t) return;
    const i = parseInt(t.dataset.threshold) || 5e3,
      a = parseInt(t.dataset.standardCost) || 495;
    let n = 0;
    if (
      (e?.total_price
        ? (n = e.total_price)
        : window.liquidAjaxCart?.cart?.total_price && (n = window.liquidAjaxCart.cart.total_price),
      n >= i)
    ) {
      const s = t.dataset.freeShippingText || "Free shipping";
      t.innerHTML = `<span class="text-success font-semibold">${s}</span>`;
    } else {
      const s = this.dataset.locale || "de-DE",
        r = this.dataset.currency || "EUR";
      t.innerHTML = `<span>${l(a, { locale: s, currency: r })}</span>`;
    }
  }
}
c("cart-drawer-component", u);
